export const GET_ALL_QUESTION_TYPES_REQUEST = "GET_ALL_QUESTION_TYPES_REQUEST";
export const GET_ALL_QUESTION_TYPES_SUCCESS = "GET_ALL_QUESTION_TYPES_SUCCESS";
export const GET_ALL_QUESTION_TYPES_FAILURE = "GET_ALL_QUESTION_TYPES_FAILURE";
